import { isB2B } from '@/domains/core/settings/utils';
import { PRLabels } from '@/domains/core/tracking/interfaces/PRLabels';
import { DetailMdScore } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';
import { getIsTopValueForMoney } from '@/domains/productDiscovery/ProductPage/b2b/utils/getIsTopValueForMoney';
import { Detail } from '@/domains/productDiscovery/ProductPage/b2c/interfaces/Detail.model';

export const getTagLabels = (
  detail: Detail,
  mdScores: Array<DetailMdScore> | undefined,
) => [
  ...(detail.isOnTopSale ? ['is_top_sales' as PRLabels] : []),
  ...(detail.isBestQualityOffer ? ['is_best_quality_offer' as PRLabels] : []),
  ...(isB2B()
    ? getIsTopValueForMoney(mdScores)
      ? ['md_top' as PRLabels]
      : []
    : mdScores?.some((md: DetailMdScore) => md.isTop && md.questionId === 1)
      ? ['md_top' as PRLabels]
      : []),
];
